export default {
  addKeyModal: {
    action: 'Appliquer',
    errorMessage:
      "Erreur d'application de la clé. Si le problème persiste, contactez l'équipe d'assistance de Metrica Sports",
    minutesMessage: 'Votre clé a été traitée. Vous avez maintenant %{minutes} minutes disponibles.',
    placeholder: 'Tapez une clé...',
    successMessage: 'La clé a été traitée avec succès',
    title: 'Ajouter une clé'
  },
  admin: {
    NoGames: 'Pas de matchs, ajoutez votre premier...',
    NoResults: 'Aucun résultat...',
    addKey: 'Ajouter une clé',
    atd: 'ATD',
    automatedTrackingData: 'Données de tracking automatisé (ATD)',
    automatedTrackingDataJobSuccess:
      'Le processus de Données de Tracking Automatisé sur %{vpName} est terminé et est maintenant disponible dans Metrica PlayBase',
    automatedTrackingDataProcessedTooltip: 'Données de détection automatisé traitées',
    awayTeam: "L'équipe visiteuse",
    awayTeamScore: 'Score par équipe visiteuse',
    ballDetection: 'Détection de balle',
    ballTracking: 'Détection du ballon',
    ballTrackingProcessedTooltip: 'Détection du ballon traitée',
    ballTrackingTooltip:
      'Ce processus détectera le ballon et vous permettra de le visualiser au sein de la Live Formation (Terrain 2D) dans PlayBase. Les coordonnées du ballon seront également disponibles dans le fichier au format FIFA EPTS.',
    cancelATDProcessSuccessfully:
      'Le traitement des données de tracking automatisé a été annulé pour %{vpName}',
    cancelDataIntegrationProcessSuccessfully:
      "Le processus d'intégration des données a été annulé pour %{vpName}",
    cancelEventsProcessSuccessfully: 'Le processus de Smart Tagging a été annulé sur %{vpName}.',
    cancelProcessTooltip: "Procédure d'annulation",
    cancelSurfacesProcessSuccessfully: 'Le traitement de superficie a été annulé le %{vpName}',
    cancelTrackingFifaFormatProcessSuccessfully:
      'Le processus de Tracking au format FIFA a été annulé pour %{vpName}',
    category: 'Catégorie',
    checking: 'Vérification...',
    cloudMinutes: 'Minutes de GameCloud',
    competition: 'Compétition',
    connectionFailed: 'Échec de la connexion',
    connectionFailedText:
      'Il semble y avoir un problème lors de la récupération des informations du statut. Vérifiez votre connexion Internet et rechargez la page. Si le problème persiste, veuillez contacter le support',
    correctedTracking: 'Tracking Correction traité',
    correctionUsage: 'Allez-vous utiliser ce projet vidéo pour le Tracking de corrections ?',
    correctionUsageTooltip:
      "Tracking Correction Manager (TCM) est un module de PlayBase orienté utilisateur pour corriger les pistes générées précédemment avec notre ATD, qui génère des données sans identifiants automatiquement pour tout match de football. Utilisez TCM pour corriger les pistes incorrectes et leur attribuer une identité. Contactez-nous pour plus d'informations.",
    createVideoProject: 'Créer un projet vidéo',
    creatingGame: "Création d'un projet vidéo...",
    dataIntegrationFailed:
      "L'intégration des données a échoué pour %{vpName}. Accédez au panneau Intégration des données, vérifiez vos fichiers et réessayez. Si l'erreur persiste, veuillez contacter l'équipe de support Metrica Sports",
    dataIntegrationJobSuccess:
      "Le processus d'intégration des données pour %{vpName} s'est terminé avec succès",
    date: 'Date',
    description: 'Description',
    editedSuccessfully: '%{vpName} a été modifié avec succès',
    errorContactSupport: "Erreur. Contacter l'équipe de support",
    errorProcessTooltip: 'Erreur de traitement',
    eventsDetection: 'Étiquetage automatique',
    eventsDetectionProcessedTooltip: 'Smart Tagging traité',
    eventsDetectionTooltip: {
      footer: '*Disponible pour des vidéos de plus de 30 minutes.',
      header:
        "Profitez de notre technologie pour détecter automatiquement une série d'événements qui se produisent dans le match*."
    },
    fieldRecognition: 'Détection de terrain',
    fieldTrackingProcessedTooltip: 'Détection de terrain traitée',
    fieldTrackingTooltip:
      'Traitement de la Détection de Champ pour ajouter des visualisations avec des valeurs de vitesse et de distance, ainsi que tous les dessins en fonction du champ dans PlayBase.',
    fileDeletedSuccessfully: '%{fileName} a été supprimé avec succès pour %{vpName}',
    fileUploadedError: 'Erreur lors du chargement de %{fileName} pour %{vpName}',
    fileUploadedSuccessfully: '%{fileName} chargé avec succès pour %{vpName}',
    forkedGameLimit:
      "Ce projet vidéo appartient à une autre organisation, il n'est donc pas possible de le modifier",
    gameDeletedSuccessfully: '%{game} supprimé avec succès',
    gameVideoProject: 'Projet de vidéo de match',
    getMoreMinutes: 'Obtenez-en plus',
    homeTeam: "L'équipe à domicile",
    homeTeamScore: "Score de l'équipe locale",
    initializing: 'Initialisation en cours...',
    jobFailed:
      "Le processus %{process} a échoué pour %{vpName}. Veuillez contacter l'équipe de support Metrica Sports",
    liveCoding: 'ou continuer pour le coding en direct ?',
    liveCodingTooltip:
      "Vous pouvez créer un projet vidéo sans sélectionner de fichier vidéo à des fins de Coding en direct. Une fois que vous avez la vidéo, vous pouvez l'ajouter pour avoir des données de tracking automatique dans le projet vidéo codé.",
    localTeamOnTheLeft:
      "L'équipe locale est-elle située sur le côté gauche du terrain en première mi-temps ?",
    localTeamOnTheLeftTooltip:
      "Afin de traiter l'étiquetage automatique, spécifiez de quel côté du terrain se trouve chaque équipe. Regardez la vidéo que vous mettez en ligne pour la valider.",
    minutes: '%{minutes} Minutes',
    noFootballSideViewTooltip:
      "Ce projet vidéo contient un fichier vidéo qui n'est pas une vidéo de football en grand angle ou en retransmission TV, de sorte que seule la détection des joueurs et des équipes a été traitée.",
    noMatches: 'Aucune correspondance...',
    noSubscriptionOwnerTooltip:
      "Contactez '%{email} ', l'administrateur de votre abonnement, pour effectuer une mise à niveau ou rendez-vous sur notre page Plans pour créer le vôtre",
    noVideoFile: 'Aucun fichier vidéo',
    notPossibleToDeleteThisEntry: 'Impossible de supprimer cette entrée',
    numberOfHalves: 'Combien de périodes ce match a-t-il ?',
    numberOfHalvesTooltip:
      "Afin de traiter l'étiquetage automatique, spécifiez le nombre de périodes du match incluses dans la vidéo que vous mettez en ligne.",
    oldAtdTooltip: "Cette vidéo a été traitée avec une ancienne version d'ATD",
    onRequest: 'Sur demande',
    organizations: 'Organisations',
    place: 'Lieu',
    playerTracking: 'Détection des joueurs et des équipes',
    playerTrackingProcessedTooltip: 'Détection des joueurs traitée',
    playerTrackingTooltip:
      "Ce processus détectera les gardiens de but et les 10 joueurs de champ de chaque équipe. Cela vous permettra de visualiser la Formation en Direct (Terrain 2D) et d'ajouter automatiquement des Visualisations de Joueurs dans PlayBase. Les coordonnées des joueurs seront également disponibles dans le fichier au format FIFA EPTS.",
    postProcessingData: 'Post-traitement des données...',
    preProcessingAtd: 'Pré-traitement...',
    processingTooltip: 'Traitement',
    readyToUpload: 'Prêt à être envoyé',
    search: 'Rechercher…',
    selectVideoFile: 'Sélectionnez un fichier vidéo',
    settingUpAtd: 'Configuration de la détection...',
    settings: 'Paramètres',
    singleVideoProject: 'Projet vidéo simple',
    startAtd: 'Démarrez ATD',
    startFifaMessage:
      "Le processus d'intégration de FIFA pour %{vpName} a commencé. Nous afficherons une notification une fois que c'est terminé. Veuillez patienter.",
    startProcessingWaitingJobsFailed: "Échec de l'envoi des tâches",
    startProcessingWaitingJobsSuccessfully: 'Travaux en attente envoyés avec succès',
    startSsMessage:
      "Le processus d'intégration de Second Spectrum %{vpName} a commencé. Nous afficherons une notification une fois que c'est terminé. Veuillez patienter.",
    startStatsMessage:
      "Le processus d'intégration de STATS pour %{vpName} a commencé. Nous afficherons une notification une fois que c'est terminé. Veuillez patienter.",
    startTracabDflMessage:
      "Le processus d'intégration Tracab DFL pour %{vpName} a commencé. Nous afficherons une notification une fois que c'est terminé. Veuillez patienter.",
    startTracabMessage:
      "Le processus d'intégration de Tracab pour %{vpName} a commencé. Nous afficherons une notification une fois que c'est terminé. Veuillez patienter.",
    surfacesJobSuccess: "Le processus de superficie %{vpName} s'est terminé avec succès",
    trackingCorrectionProcessedTooltip: 'Tracking Correction traité',
    trackingFifaFormatJobSuccess:
      "Le processus de détection au format FIFA pour %{vpName} s'est terminé avec succès. Vous pouvez maintenant télécharger le fichier en cliquant sur l'élément de menu Télécharger le format FIFA",
    trackingLicence: "Vous n'avez pas de licence de Tracking",
    uncaughtErrorRow:
      'Erreur du projet vidéo. Veuillez actualiser cette page. Si le problème persiste, contactez le support ou supprimez-le et créez-le à nouveau.',
    updatingGame: 'Mise à jour du projet vidéo...',
    upgradePlan: 'Mettre à jour',
    uploadAndTracking: 'Chargement et Tracking',
    uploadingVideoFile: "Chargement d'un fichier vidéo",
    videoFile: 'Fichier vidéo',
    videoFootballSideView:
      'Ce fichier vidéo est-il une vidéo de football en grand-angle ou en retransmission TV ?',
    videoFootballSideViewTooltip:
      'La détection du terrain est optimisée pour ce type de vidéos uniquement.',
    videoMultipartStart:
      '%{videoName} est en cours de téléchargement sur %{vpName}. NE FERMEZ PAS CETTE PAGE avant la fin du chargement',
    videoPlaylist: 'Ce fichier vidéo est-il une liste de lecture ?',
    videoPlaylistTooltip:
      'Si vous sélectionnez OUI, la Détection de Clips sera exécutée pour reconnaître quand une coupure se produit dans la vidéo, ce qui en fait un outil parfait si vous téléchargez une vidéo contenant plusieurs clips, par exemple. Après avoir exécuté ce processus, téléchargez le Projet Vidéo dans PlayBase et un fichier de Coding de Détection de Clips sera là avec un code incluant chaque coupure comme un événement.',
    videoProjectSettings: 'Paramètres du projet vidéo',
    videoUploadError:
      'Le chargement de la vidéo de %{videoName} pour %{vpName} a échoué. Veuillez réessayer',
    videoUploaded: '%{videoName} a été chargé sur %{vpName}',
    vpCreated: '%{vpName} a été créé',
    waitingAtd: 'En attente…'
  },
  billing: {
    address: 'Adresse',
    billed: 'Facturé',
    completed: 'Payé',
    details: 'Détails de Facturation',
    history: 'Historique de Facturation',
    invoiceNotFound: 'Facture non trouvée',
    noInvoices: 'Pas de factures',
    past_due: 'Échu',
    taxId: "Numéro d'identification fiscale"
  },
  checkout: {
    chargeSubscription: "Facturer à l'abonnement",
    costOneTime: '%{currency} %{cost}',
    costRecurrent: '%{currency} %{cost} %{cycle}',
    discountCodes: '*Les codes de réduction peuvent être appliqués lors du paiement.',
    dueToday: "À Payer Aujourd'hui",
    excTax: '(Hors taxes)',
    halfYear: '6 mois',
    halfYearlyBilled: 'Facturé tous les 6 mois',
    immediatePayment: 'Paiement Immédiat',
    incTax: '(TTC)',
    month: 'mois',
    monthlyBilled: 'Facturé mensuellement',
    nextPayment: 'Prochain Paiement',
    noPacks: 'Sans Minutes de GameCloud',
    onDate: 'le %{date}',
    packs: 'Packs',
    packsTotal: 'Packs Total',
    perHalfYear: '/6 mois',
    perMonth: '/mois',
    perYear: '/année',
    plans: 'Plans',
    plansTotal: 'Total des Plans',
    proceed: 'Procéder au paiement',
    subtotal: 'Sous-total',
    taxPayable: 'Impôts à payer (%{percentage}%)',
    total: 'Total',
    unpaid:
      "Votre dernière facture n'a pas encore été payée. Veuillez mettre à jour vos informations de paiement pour continuer.",
    updatePaymentMethod: 'Mettre à jour la méthode de paiement',
    updateSubscription: "Mettre à jour l'abonnement",
    upgradeTo: 'Mettre à Niveau Vers %{plan}',
    userDevice: '1 utilisateur/appareil',
    usersDevices: '%{number} utilisateurs/appareils',
    year: 'année',
    yearlyBilled: 'Facturé annuellement'
  },
  common: {
    add: 'Ajouter',
    back: 'Retour',
    cancel: 'Annuler',
    canceling: 'Annulation…',
    clearAll: 'Tout effacer',
    continue: 'Continuer',
    create: 'Créer',
    deactivate: 'Désactiver',
    edit: 'Éditer',
    email: 'Email',
    errorMsg:
      'Erreur lors du traitement de %{name}. Pour toute demande, veuillez contacter le support.',
    errorTryAgain: 'Erreur. Essayez à nouveau',
    genericError:
      'Erreur, le processus a échoué. Pour toute demande, veuillez contacter le support.',
    loading: 'Chargement…',
    login: 'Connexion',
    logout: 'Déconnexion',
    new: 'Nouveau',
    next: 'Suivant',
    no: 'Non',
    noFileChosen: 'Aucun fichier choisi',
    ok: 'Valider',
    pending: 'En attente',
    required: 'Obligatoire',
    reset: 'Réinitialiser le mot de passe',
    restart: 'Redémarrer',
    save: 'Enregistrer',
    selectFile: 'Sélectionner un fichier',
    sort: 'Trier',
    start: 'Commencez',
    today: "Aujourd'hui",
    unassigned: 'Non Assigné',
    uploading: 'Chargement en cours...',
    yes: 'Oui'
  },
  confirmModal: {
    description: 'Êtes vous sûr ?',
    title: 'Confirmer'
  },
  container: {
    download: 'Télécharger Fichier Conteneur',
    notProcessed: "Le fichier de Conteneur n'a pas été traité dans ce Projet de Vidéo.",
    processed: 'Fichier de Conteneur traité',
    title: 'Conteneur',
    titleDownload: 'Télécharger Container'
  },
  dataIntegration: {
    deleteFile: 'Supprimer le fichier',
    featureNotAvailable:
      "Cette fonctionnalité n'est pas disponible dans votre forfait actuel. Vous devez passer à un autre forfait pour bénéficier de cette fonctionnalité. Contactez-nous pour plus d'informations",
    notSideView:
      "L'intégration des données n'est pas disponible pour les projets vidéo dont le fichier vidéo n'est pas une vidéo de football en grand angle ou en retransmission TV.",
    open: "Ouvrir l'intégration des données",
    processJobsFirst:
      "Vous devez commencer à traiter les données de tracking automatisé (ATD) avant d'accéder au panneau d'intégration des données",
    processed: 'Intégration des données traitée',
    selectFile: 'Sélectionner un fichier',
    startProcess: 'Démarrage du processus',
    title: 'Intégration des données',
    waiting: "Processus d'attente...",
    waitingProcess:
      "Le processus d'intégration commencera une fois que les processus de détection des joueurs et des champs seront terminés."
  },
  deleteModal: {
    checkboxLabel: "Je souhaite également ne plus recevoir d'e-mails de Metrica Sports",
    confirmationType: 'Tapez %{validateFormKey} pour confirmer :',
    deleteAction: 'Oui, supprimez-le',
    description: 'Êtes-vous sûr de vouloir supprimer définitivement votre compte ?',
    information:
      'Vous perdrez tous les projets vidéo créés avec ce compte. Nous ne pouvons pas les récupérer une fois que vous les supprimez.',
    keepAccount: 'Garder le compte',
    suggestion: 'Nous vous conseillons de conserver votre compte.',
    title: 'Supprimer pour toujours ?',
    validateFormKey: 'SUPPRIMER'
  },
  error: {
    oops: 'OUPS!',
    restart:
      "On dirait que vous essayez d'utiliser quelque chose que nous sommes encore en train de développer..."
  },
  eventsDetection: {
    automaticVp:
      "Smart Tagging non disponible sur les Projets Vidéo avec une version antérieure d'ATD.",
    download: 'Télécharger des événements de Smart Tagging au format XML',
    needsAtd:
      "Démarrez d'abord le processus ATD pour pouvoir exécuter le processus de Smart Tagging.",
    needsFootballSideView:
      "Smart Tagging non disponible sur les Projets Vidéo contenant un fichier vidéo qui n'est pas un match de football filmé en plan large ou diffusé à la télévision.",
    needsGameVp: 'Smart Tagging est uniquement disponible sur les Projets de Vidéo de Match.',
    needsNoPlaylist:
      "Le Smart Tagging n'est pas disponible sur les Projets Vidéo contenant un fichier vidéo qui est une playlist."
  },
  forgotPassword: {
    adminNoResetPassword:
      'Les utilisateurs administrateurs doivent utiliser un point de terminaison privé pour réinitialiser leur mot de passe',
    notFound: 'Utilisateur introuvable. Veuillez réessayer avec une adresse e-mail valide',
    success: 'Réinitialisation du mot de passe! Merci de consulter vos emails'
  },
  groups: {
    addMembers: 'Ajouter des membres',
    addOrUpdateErrorMessage:
      "Erreur lors du traitement du groupe. Si le problème persiste, contactez l'équipe de support de Metrica Sports",
    availableMinutes: 'Minutes Disponibles',
    availableMinutesWarning: 'Vous avez %{availableMinutes} minutes à assigner à une organisation',
    createGroup: 'Créer Groupe',
    deleteErrorMessage:
      "Erreur lors de la suppression du groupe. Si le problème persiste, contactez l'équipe de support de Metrica Sports",
    deleteGroup: 'Supprimer Groupe',
    deleteGroupDescription:
      'Vous essayez de supprimer le groupe %{pre}%{name}%{post}. Si un Projet de Vidéo est lié à ce groupe, les utilisateurs ne pourront plus y accéder.',
    deleteNow: 'Supprimer maintenant',
    deleteThisGroup: 'Supprimer ce groupe',
    editGroup: 'Éditer Groupe',
    enterEmails: 'Entrez les adresses e-mails des utilisateurs que vous souhaitez ajouter',
    enterGroupName: 'Entrez le nom du groupe',
    enterValidName: "S'il vous plaît, entrez un nom valide",
    gameCloudMinutes: 'Minutes de GameCloud',
    groupMembers: 'Membres du groupe',
    groupName: 'Nom du groupe',
    manageGameCloudMinutes: 'Gérer les Minutes de GameCloud',
    minutesErrorMessage:
      "Erreur lors de la gestion des minutes. Si le problème persiste, contactez l'équipe de support de Metrica Sports",
    moreLicensesDescription:
      "Pour ajouter des utilisateurs avec licence à votre compte, veuillez, s'il vous plaît, acheter plus de licences",
    name: 'Nom du Groupe',
    noMultiLicenseDescription: 'Seuls les plans multi-licence sont autorisés à créer des groupes',
    noPermissionDescription:
      "Votre utilisateur appartient à l'organisation %{pre}%{ownerEmail}%{post}, contactez le propriétaire pour mettre à jour ou effectuer des modifications"
  },
  login: {
    clickHere: 'Cliquez ici',
    contactUs: 'Contactez-nous',
    dontHaveAccount: "Je n'ai pas de compte. %{pre}Inscrivez-vous%{post}",
    enterYourEmail: 'Entrer votre Email',
    enterYourPassword: 'Saisissez votre mot de passe',
    forgotPassword: "J'ai oublié mon mot de passe. %{pre}Cliquez ici%{post}",
    invalidEmail: 'Adresse e-mail non valide',
    licenceExpired: 'Votre licence a expiré.',
    trialExpired: "Votre période d'essai a expiré.",
    upgradePlan: 'Mettez à jour votre plan'
  },
  patterns: {
    delete: 'Supprimer le fichier de modèles',
    title: 'Fichier de modèles personnalisés',
    upload: 'Télécharger un fichier de modèle personnalisé',
    uploaded: 'Fichier de Modèles chargé',
    uploading: 'Chargement du fichier Modèle'
  },
  plans: {
    academic: 'Académique',
    addMoreProducts: '+ Ajouter plus de produits',
    admin: 'Admin',
    basic: 'Basic',
    basicCodePadMonthly: 'Basic+Code Mensuel',
    basicCodePadYearly: 'Basic+Code Annuel',
    basicMftCodePadMonthly: 'Full Basic Mensuel',
    basicMftCodePadYearly: 'Full Basic Annuel',
    basicMftMonthly: 'Basic+MFT Mensuel',
    basicMftXmlMonthly: 'Basic MFT + XML Mensuel',
    basicMftXmlYearly: 'Basic MFT + XML Annuel',
    basicMftYearly: 'Basic+MFT Annuel',
    basicMonthly: 'Basic Mensuel',
    basicXmlMonthly: 'Basic XML Mensuel',
    basicXmlYearly: 'Basic XML Annuel',
    basicYearly: 'Basic Annuel',
    code: 'Code',
    elite: 'Elite',
    elite2024Yearly: 'Elite Annuel',
    eliteYearly: 'Elite Annuel',
    essentialsCodeMonthly: 'Essentials + Code ∞ Mensuel',
    essentialsCodeYearly: 'Essentials + Code ∞ Annuel',
    essentialsMftCodeMonthly: 'Full Essentials Mensuel',
    essentialsMftCodeYearly: 'Full Essentials Annuel',
    essentialsMftMonthly: 'Essentials + MFT Mensuel',
    essentialsMftYearly: 'Essentials + MFT Annuel',
    essentialsMonthly: 'Essentials Mensuel',
    essentialsYearly: 'Essentials Annuel',
    influencer: 'Influencer',
    lite: 'Lite',
    liteMonthly: 'Lite Mensuel',
    liteYearly: 'Lite Annuel',
    minutes10: '10 Minutes de GameCloud',
    minutes100: '100 Minutes de GameCloud',
    minutes1000: '1.000 Minutes de GameCloud',
    minutes10000: '10.000 Minutes de GameCloud',
    plan: 'Plan %{planName}',
    planHalfYearly: 'Plan %{planName} Semestriel',
    planMonthly: 'Plan %{planName} Mensuel',
    planYearly: 'Plan %{planName} Annuel',
    primeLiveMonthly: 'Prime + Live Mensuel',
    primeLiveYearly: 'Prime + Live Annuel',
    primeMftLiveMonthly: 'Prime + MFT + Live Mensuel',
    primeMftLiveYearly: 'Prime + MFT + Live Annuel',
    primeMftMonthly: 'Prime + MFT Mensuel',
    primeMftYearly: 'Prime + MFT Annuel',
    primeMonthly: 'Prime Mensuel',
    primePresetsLiveMonthly: 'Prime + Presets + Live Mensuel',
    primePresetsLiveYearly: 'Prime + Presets + Live Annuel',
    primePresetsMftLiveMonthly: 'Full Prime Mensuel',
    primePresetsMftLiveYearly: 'Full Prime Annuel',
    primePresetsMftMonthly: 'Prime + Presets + MFT Mensuel',
    primePresetsMftYearly: 'Prime + Presets + MFT Annuel',
    primePresetsMonthly: 'Prime + Presets Mensuel',
    primePresetsYearly: 'Prime + Presets Annuel',
    primeYearly: 'Prime Annuel',
    pro: 'Pro',
    pro2024LiveMonthly: 'Pro + Live Mensuel',
    pro2024LiveYearly: 'Pro + Live Annuel',
    pro2024Monthly: 'Pro Mensuel',
    pro2024Yearly: 'Pro Annuel',
    proYearly: 'Pro Annuel',
    starter: 'Starter',
    starterCodeMonthly: 'Starter + Code ∞ Mensuel',
    starterCodePadMonthly: 'Code Mensuel',
    starterCodePauseMonthly: 'Full Starter Mensuel',
    starterCodePauseYearly: 'Full Starter Annuel',
    starterCodeYearly: 'Starter + Code ∞ Annuel',
    starterPauseMonthly: 'Starter + Pause ∞ Mensuel',
    starterPauseYearly: 'Starter + Pause ∞ Annuel',
    student: 'Étudiant',
    trial: 'Trial'
  },
  playlist: {
    download: 'Télécharger le fichier de la liste de lecture',
    notProcessed: "Le fichier de playlist n'a pas été traité dans ce projet vidéo.",
    processed: 'Fichier de liste de lecture traité',
    title: 'Liste de lecture',
    titleDownload: 'Télécharger la liste de lecture'
  },
  products: {
    addOns: 'Extensions',
    basic: 'Codes et Annotations Illimités',
    code: 'CodePad',
    elite: {
      description:
        'Automatisez et personnalisez l\'ensemble de votre flux de travail d\'analyse. Ce plan inclut un accès complet à PlayBase avec toutes les fonctionnalités du Plan "Full Essentials" et un accès à Metrica Nexus avec toutes les fonctionnalités du Plan "Pro".',
      feature1: '✓ Stockage Cloud partagé',
      feature2: '✓ Intégration des Données de Tracking',
      feature3: '✓ Gestionnaire de Correction de Suivi',
      feature4: '✓ RESTful API'
    },
    essentials: {
      addon1: 'Fonctionnalités de Coding illimitées (CodePad, Coding en Direct et Importation XML)',
      addon2: 'Suivi Manuel de Terrain',
      essentialsCodeDescription:
        "Ce plan permet d'activer les Visualisations Dynamiques pour ajouter des annotations de mouvement illimitées lors de la lecture de la vidéo et pendant les pauses. Ce plan n'inclut pas le Tracking de Champ Manuel, donc les visualisations de Vitesse et Distance ne sont pas incluses. Il débloque également la limitation des fonctionnalités de coding telles que CodePad, le Coding en Direct et l'Importation XML et supprime la limite de 4 codes par Projet Vidéo pour passer à des codes illimités.",
      essentialsDescription:
        "Ce plan permet l'utilisation de la Téléstration Dynamique disponible pour ajouter des visualisations de mouvement illimitées lors de la lecture de la vidéo et pendant les pauses. Ce plan n'inclut pas le Tracking de Champ Manuel, donc les visualisations de Vitesse et Distance ne sont pas incluses. Les fonctionnalités de coding restent limitées.",
      essentialsMftCodeDescription:
        'Ce plan permet les Visualisations Dynamiques disponibles pour ajouter des annotations de mouvement illimitées lors de la lecture de la vidéo et lors des pauses, et active également le Tracking de Champ Manuel pour ajouter des visualisations de vitesse et de distance. Il débloque également la limitation des fonctionnalités de coding telles que CodePad, Coding en Direct et Importation XML et supprime la limite de 4 codes par Projet Vidéo pour un nombre illimité de codes.',
      essentialsMftDescription:
        "Ce plan permet d'activer les Visualisations Dynamiques disponibles pour ajouter des annotations de mouvement illimitées lors de la lecture de la vidéo et pendant les pauses, et active également le Tracking de Champ Manuel pour ajouter des visualisations de vitesse et de distance. Les fonctionnalités de coding restent limitées.",
      feature1: "✓ Codage post-match (Code Table avec jusqu'à 4 codes)",
      feature2: '✓ Téléstration illimitée en pause',
      feature3: '✓ Téléstration dynamique'
    },
    featuresIncluded: 'Fonctionnalités incluses :',
    freeFeature1: "✓ Codage post-match (Code Table avec jusqu'à 4 codes)",
    freeFeature2: '✓ Suivi manuel',
    freeFeature3: "✓ Téléstration (jusqu'à 50 annotations)",
    freeFeature4: '✓ Exportation de vidéo',
    freeFeatures: 'Fonctionnalités Gratuites',
    fullBasic: 'Suivi Manuel du Terrain',
    lite: 'Suivi Automatique des Joueurs et du Terrain',
    liteDescription:
      'Codage avancé et visualisations avancées. Tout automatique, le rendant 3 fois plus rapide que Full Basic !',
    minutesDescription:
      "Rechargez n'importe quel plan. Obtenez des packs de minutes pour les Données de Tracking Automatisé.",
    minutesPack: 'Pack de Minutes GameCloud',
    nexus_elite: {
      description: 'Pour les meilleures équipes du monde',
      feature1: '✓ Toutes les fonctionnalités Pro',
      feature2: '✓ Tracking de Clip Complet',
      feature3: '✓ Nexus Live (Capture en Direct + Nexus Mobile)'
    },
    nexus_prime: {
      addon1: 'Nexus Live (Capture en Direct + Nexus Mobile)',
      description: "Solution d'entrée de gamme",
      feature1: '✓ Analyse de Match Complet',
      feature2: '✓ Téléstration Complète',
      feature3: '✓ Tracking Manuel'
    },
    nexus_pro: {
      addon1: 'Nexus Live (Capture en Direct + Nexus Mobile)',
      description: 'Automatisez votre flux de travail',
      feature1: '✓ Analyse de Match Complet',
      feature2: '✓ Téléstration Complète',
      feature3: '✓ Tracking Automatique'
    },
    otherDescription:
      'Fonctionnalités de coding avancées avec téléstration basique et annotations limitées.',
    playbase_advanced: {
      description: 'Analyse Complètement Automatisée',
      feature1: '✓ Analyse de Match Complet',
      feature2: '✓ Téléstration en Mouvement',
      feature3: '✓ Tracking Automatique'
    },
    playbase_essentials: {
      description: "Solution d'entrée de gamme",
      feature1: '✓ Analyse de Match Complet',
      feature2: '✓ Téléstration sur Pauses'
    },
    playbase_plus: {
      description: 'Fais du Tracking à ton propre rythme',
      feature1: '✓ Analyse de Match Complet',
      feature2: '✓ Téléstration en Mouvement',
      feature3: '✓ Tracking Manuel'
    },
    prime: {
      addon1: 'Suivi Manuel de Terrain',
      addon2:
        'Visualisations Personnalisées (personnalisez et sauvegardez vos propres visualisations)',
      addon3: 'Enregistrement en Direct (capture, analyse et partage de moments forts sur le vif)',
      feature1:
        '✓ Accès complet à PlayBase avec toutes les fonctionnalités du Plan "Full Essentials"',
      feature2: '✓ Accès à Metrica Nexus avec :',
      feature2_1: 'Pauses séquentielles',
      feature2_2: 'Téléstration avancée',
      feature2_3: 'Exportation de vidéos personnalisée',
      primeDescription:
        'Ce plan inclut un accès complet à PlayBase avec toutes les fonctionnalités du Plan "Essentials + Code ∞" et active Metrica Nexus avec des téléstrations avancées.',
      primeMftDescription:
        'Ce plan inclut un accès complet à PlayBase avec toutes les fonctionnalités du Plan "Full Essentials" et active Metrica Nexus avec des téléstrations avancées.',
      primePresetsDescription:
        'Ce plan inclut un accès complet à PlayBase avec toutes les fonctionnalités du Plan "Essentials + Code ∞" et active Metrica Nexus avec des téléstrations avancées et des visualisations personnalisées.',
      primePresetsMftDescription:
        'Ce plan inclut un accès complet à PlayBase avec toutes les fonctionnalités du Plan "Full Essentials" et active Metrica Nexus avec des téléstrations avancées et des visualisations personnalisées.'
    },
    pro: {
      addon1: 'Enregistrement en Direct (capture, analyse et partage de moments forts sur le vif)',
      description:
        'Ce plan inclut un accès complet à PlayBase avec toutes les fonctionnalités du Plan "Full Essentials" et un accès à Metrica Nexus avec toutes les fonctionnalités du Plan "Full Prime".',
      feature1: '✓ Suivi Automatique des Joueurs',
      feature2: '✓ Suivi Automatique du Terrain',
      feature3:
        '✓ Accès complet à PlayBase avec toutes les fonctionnalités du Plan "Full Essentials"',
      feature4: '✓ Accès à Metrica Nexus avec :',
      feature4_1: 'Pauses séquentielles',
      feature4_2: 'Téléstration avancée',
      feature4_3: 'Exportation de vidéos personnalisée',
      feature4_4:
        'Visualisations Personnalisées (personnalisez et sauvegardez vos propres visualisations)'
    },
    remove: 'Supprimer',
    starter: {
      addon1: 'Téléstration illimitée pendant les pauses',
      addon2: 'Fonctionnalités de Coding illimitées (CodePad, Coding en Direct et Importation XML)',
      feature1: "✓ Codage post-match (Code Table avec jusqu'à 4 codes)",
      feature2: "✓ Téléstration pendant les pauses (jusqu'à 50 annotations par mois)",
      feature3: '✓ Exportation de vidéos',
      starterCodeDescription:
        'Ce plan débloque la limitation des fonctionnalités de codage telles que CodePad, Coding en Direct et Importation XML. Il libère également la limite de 4 codes par Projet Vidéo pour un nombre illimité de codes. Les limitations des fonctionnalités de téléstration restent celles du Free Starter.',
      starterCodePauseDescription:
        'Ce plan débloque la limitation des fonctionnalités de codage telles que CodePad, Coding en Direct et Importation XML. Il libère également la limite de 4 codes par Projet Vidéo pour passer à des codes illimités, et débloque la limitation de téléstration en pauses de 50 par mois à illimité.',
      starterPauseDescription:
        'Ce plan débloque la limitation de téléstration en pauses de 50 par mois à illimité. Les limitations des fonctionnalités de coding restent dans Free Starter.'
    },
    totalPack: '%{currency} %{cost}'
  },
  settings: {
    billing: 'Facturation',
    billingSettings: 'Paramètres de facturation',
    billingSettingsDescription: '(modifier votre plan, mettre à jour les modes de paiement...)',
    cancelAt: "Votre plan s'annule le",
    cancelPlan: 'Annuler le plan',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    deleteAccount: 'Supprimer le compte',
    details: 'Mes détails',
    devices: 'Appareils',
    devicesResetError: 'Erreur lors de la réinitialisation des dispositifs. Veuillez réessayer',
    devicesResetSuccess: 'Tous vos appareils ont été réinitialisés avec succès',
    emailNotActivated: 'La notification par e-mail est désormais activée',
    emailNotDeactivated: 'La notification par e-mail est désormais désactivée',
    emailNotifications: 'Notification par e-mail',
    groups: 'Groupes',
    language: 'Langue',
    languageChanged: 'La langue a été mise à jour',
    manualResetDevices: 'Contactez le support pour réinitialiser vos dispositifs',
    newPassword: 'Nouveau mot de passe',
    noDevicesToReset: 'Aucun appareil à réinitialiser',
    noOwner:
      "Votre plan appartient à l'organisation %{pre}%{email}%{post}, contactez le propriétaire pour mettre à jour ou effectuer des modifications",
    organizationLabel: "Préfixe de l'organisation",
    organizationTooltip:
      "Ce préfixe est nécessaire pour importer des Modèles personnalisés dans un projet vidéo. Contactez-nous pour plus d'informations ou consultez la documentation sur codeball.metrica-sports.com",
    passwordsDontMatch: 'Les mots de passe ne correspondent pas',
    passwordInvalid: 'Le mot de passe ne respecte pas les exigences',
    passwordRequirements: {
      minLength: 'Au moins %{count} caractères',
      uppercase: 'Une lettre majuscule',
      lowercase: 'Une lettre minuscule',
      number: 'Un chiffre (0-9)',
      maxLength: 'Au plus %{count} caractères'
    },
    pauseAt: 'Votre plan se met en pause le',
    planCanceled: "Votre plan a été annulé. Vérifiez votre e-mail pour plus d'informations",
    plans: 'Plans',
    quantity: 'Quantité :',
    remainingResets: '%{current}/%{max} commutations restantes cette année',
    renewAt: 'Votre plan se renouvelle le',
    resetDeviceAction: 'Réinitialiser Dispositifs',
    title: 'Paramètres',
    upgradePlan: 'Actualisation du Plan',
    userKey: 'Clé utilisateur :',
    userKeyUsages: '%{current}/%{max} utilisations',
    userSettings: 'Paramètres utilisateurs',
    users: 'Utilisateurs'
  },
  shoppingCart: {
    subtitle:
      'Choisissez votre plan Metrica Sports et ajoutez des compléments pour élever votre performance.',
    title: 'Configurez votre Metrica Sports'
  },
  subscription: {
    cancelSubscription: "Annuler l'abonnement",
    errorUpdating:
      'Il y a eu une erreur lors de la mise à jour de votre abonnement. Veuillez envoyer un courriel à support@metrica-sports.com et nous serons ravis de vous aider.',
    free: 'Gratuit',
    isObsolete:
      'Votre abonnement ne peut pas être modifié. Remplacez les produits obsolètes par de nouveaux pour activer les changements.',
    pendingRefundRequest:
      "Il est impossible d'apporter d'autres modifications à cet abonnement tant qu'une demande de remboursement est en attente.",
    planMigrationMessage:
      "À partir du 1er avril, votre abonnement <strong>%{currentPlan}</strong> sera appelé <strong>%{newPlan}</strong>, mais aucun frais ne vous sera facturé. Aucune action n'est requise de votre part. Le <strong>%{date}</strong>, le prix de votre plan sera de <strong>%{newPrice}</strong> par utilisateur, par <strong>%{cycle}</strong>. Pour en savoir plus sur tous les nouveaux plans <a href='%{link}'>cliquez ici</a>.",
    undoCancel: "Annuler l'annulation de l'abonnement.",
    undoPause: "Annuler la pause de l'abonnement.",
    updatePaymentMethod: 'Mettre à jour la méthode de paiement',
    updatedSuccessfully: 'Abonnement mis à jour avec succès',
    yourPlans: 'Vos Plans',
    yourSubscription: 'Votre abonnement'
  },
  successfulPayment: {
    addUsers: "Ajoutez d'autres utilisateurs à votre organisation.",
    allTheBest: 'Tout le meilleur,',
    applyKey: 'Appliquer la clé à ce compte',
    applyKeyDescription: 'Souhaitez-vous activer cette licence pour votre compte ?',
    assignLicenses: 'Transfère ta licence à un autre compte.',
    download:
      'Rendez-vous sur la %{pre}Page de Téléchargements%{post} sur notre site web et téléchargez PlayBase ou Nexus, selon votre licence.',
    faq: "Voici comment commencer rapidement et d'autres informations pertinentes :",
    happyPlay:
      "Nous espérons que tout est clair, mais n'hésitez pas à nous contacter si vous avez d'autres questions ou doutes.",
    helpCenter:
      "Jetez un œil à notre %{pre}Centre d'Aide%{post} pour de nombreux articles utiles, tels que des tutoriels complets et des questions fréquentes.",
    howToCancel:
      "Veuillez noter que votre abonnement est renouvelé automatiquement jusqu'à ce qu'il soit %{pre}annulé explicitement via les paramètres de GameCloud%{post}, conformément à nos Termes et Conditions.",
    keyApplied: 'Clé appliquée',
    licenseActivation1:
      "Si vous n'aviez pas encore de licence active pour votre compte, votre licence nouvellement acquise a été activée automatiquement.",
    licenseActivation2:
      "Si votre licence n'a pas été activée pour une raison quelconque, vous pouvez l'activer ci-dessous :",
    licenseKey: 'Votre clé de licence est : %{pre}%{licenseKey}%{post}',
    licensesTitle: 'Activation de la Licence',
    metricaSportsTeam: "— L'équipe de Metrica Sports",
    minutesInfo:
      "Si vous souhaitez distribuer vos minutes de GameCloud entre différents groupes d'utilisateurs, rendez-vous sur l'onglet Groupes dans la %{pre}Page de Configuration%{post}.",
    minutesTitle: 'Vos Minutes de GameCloud',
    renewalInfo:
      "Veuillez noter que votre abonnement est renouvelé automatiquement jusqu'à ce qu'il soit %{pre}annulé explicitement via les paramètres de GameCloud%{post}, conformément à nos Termes et Conditions.",
    settingsCloud:
      'Visitez notre %{pre}GameCloud%{post} et naviguez vers le menu des Paramètres pour :',
    technicalSupport: 'Pour le support technique, %{pre}contactez-nous%{post} directement.',
    thanks: "Merci pour votre commande, nous l'avons traitée avec succès !",
    title: 'Confirmation de commande',
    updatePayment: 'Mettez à jour votre méthode de paiement.',
    updateSubscription: 'Annulez ou modifiez votre abonnement.'
  },
  surfaces: {
    automaticVp: 'Superficies non disponibles sur les projets vidéo avec une ancienne version ATD',
    delete: 'Supprimer le fichier Superficie',
    needsAtd: "Démarrez d'abord le processus ATD pour exécuter les processus de Superficie",
    needsElite:
      "Superficies personnalisées disponibles sur le plan Elite. Contactez-nous pour plus d'informations",
    needsFootballSideView:
      "Superficies non disponibles dans les projets vidéo dont le fichier vidéo n'est pas une vidéo de football en grand angle ou en retransmission TV",
    pitchControl:
      'En exécutant ce processus, vous pourrez ajouter la visualisation de Pitch Control dans PlayBase.',
    pitchControlProcessed: 'Superficie de Pitch Control traitée',
    pitchControlProcessing: 'Traitement du Pitch Control',
    processed: 'Fichier Superficie chargé',
    processing: 'Traitement du fichier de Superficie',
    title: 'Superficies',
    titlePitchControl: 'Pitch Control',
    upload: 'Téléchargez votre propre Superficie',
    uploading: 'Chargement de Superficie...'
  },
  trackingFifaFormat: {
    download: 'Télécharger le fichier au format FIFA EPTS',
    needsElite:
      "Cette fonction n'est disponible qu'après avoir importé les fichiers correspondants dans le module d'intégration de données, les projets vidéo avec données de tracking automatisé ou les projets vidéo dans le plan Elite.",
    processed: 'Traitement du format FIFA EPTS',
    start:
      'Démarrez le processus pour générer le fichier au format FIFA EPTS. Vous pourrez ensuite télécharger le fichier',
    title: 'Format EPTS de la FIFA',
    titleDownload: 'Télécharger le format FIFA EPTS'
  },
  upgradeModal: {
    linksDescription: 'Obtenez le pack minutes GameCloud qui vous convient le mieux :',
    minutePackLinks: {
      minutes_10: 'Bénéficiez de 10 minutes pour 10€',
      minutes_100: 'Bénéficiez de 100 minutes pour 90€',
      minutes_1000: 'Bénéficiez de 1.000 minutes pour 750€',
      minutes_10000: 'Bénéficiez de 10 000 minutes pour 5 000€'
    },
    noMinutes: {
      description:
        'Vous ne disposez pas de suffisamment de minutes pour créer ce projet vidéo. Savez-vous que vous pouvez obtenir des packs de minutes quel que soit votre plan ?',
      secondDescription: '',
      title: 'Obtenez plus de minutes pour créer un projet vidéo !'
    },
    notEnoughMinutes: {
      description:
        'Nous sommes désolés de vous informer que vous ne disposez pas de suffisamment de minutes pour le traitement ATD de vos projets vidéo.',
      secondDescription:
        "Si vous voulez traiter l'ATD, vous devrez ajouter des minutes supplémentaires à votre compte. Les minutes que vous obtiendrez n'expirent pas !",
      title: 'Minutes disponibles insuffisantes'
    }
  },
  users: {
    addEmails: 'Ajouter des utilisateurs avec leurs adresses de courriel',
    addErrorMessage:
      "Erreur lors de l'ajout d'utilisateurs. Si le problème persiste, contactez l'équipe de support de Metrica Sports",
    addUsers: 'Ajouter des Utilisateurs',
    availableLicenses: '%{planName} (%{count} disponibles%{renewal})',
    currentLicense: '%{planName} (actuel%{renewal})',
    deactivateErrorMessage:
      "Erreur lors de la désactivation de l'utilisateur. Si le problème persiste, contactez l'équipe de support de Metrica Sports",
    deactivateNow: 'Désactiver maintenant',
    deactivateUser: 'Désactiver Utilisateur',
    deactivateUserDescription:
      "Vous essayez de désactiver l'utilisateur %{pre}%{email}%{post}. L'utilisateur ne pourra accéder à aucun service de Metrica Sports et sera changé au plan Free.",
    editUser: 'Modifier Utilisateur',
    enterGroup: 'Entrer dans le groupe',
    exportUsers: 'Exporter Utilisateurs',
    filteredUsers: '%{nUsers} sur %{totalUsers} utilisateurs',
    firstName: 'Prénom',
    lastName: 'Nom de Famille',
    plan: 'Plan',
    renewsOn: ', renouvelle le %{date}',
    role: 'Rôle',
    roles: {
      admin: 'Administrateur',
      member: 'Membre',
      owner: 'Propriétaire'
    },
    unlinkErrorMessage:
      "Erreur lors de la désassociation de l'utilisateur. Si le problème persiste, contactez l'équipe de support de Metrica Sports",
    unlinkFromYourAccount: 'Se désinscrire de votre compte',
    unlinkNow: 'Dissocier maintenant',
    unlinkUser: 'Dissocier Utilisateur',
    unlinkUserDescription:
      "Vous essayez de dissocier l'utilisateur %{pre}%{email}%{post}. L'utilisateur ne pourra accéder à aucun service de Metrica Sports et sera changé au plan Free.",
    updateErrorMessage:
      "Erreur lors de la mise à jour de l'utilisateur. Si le problème persiste, contactez l'équipe de support de Metrica Sports",
    useComma: 'Utilisez une virgule pour séparer différentes adresses de courriel',
    userGroups: "Groupes d'utilisateur"
  },
  video: {
    cancelUpload: 'Annuler le chargement',
    delete: 'Supprimer la vidéo',
    download: 'Télécharger la vidéo',
    title: 'Fichier vidéo',
    upload: 'Upload vidéo',
    uploaded: 'Vidéo téléchargée',
    uploading: 'Chargement de la vidéo'
  },
  videoProject: {
    delete: 'Supprimer le projet vidéo',
    edit: 'Modifier le projet vidéo',
    processWaitingJobs: 'Traitement des tâches en attente',
    title: 'Projet vidéo'
  }
}
